import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const categories = [{
  id: 'jp-kr',
  title: '日韩佳丽',
  subtitle: 'Japan & Korea',
  desc: '温婉贤淑，精致迷人',
  gradient: 'from-pink-900/40 to-purple-900/40',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=600&h=800&fit=crop&crop=faces'
}, {
  id: 'eu-us',
  title: '欧美名媛',
  subtitle: 'Europe & America',
  desc: '热情奔放，风情万种',
  gradient: 'from-blue-900/40 to-indigo-900/40',
  image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=600&h=800&fit=crop&crop=faces'
}, {
  id: 'vn',
  title: '越南风情',
  subtitle: 'Vietnam',
  desc: '温柔似水，婀娜多姿',
  gradient: 'from-emerald-900/40 to-teal-900/40',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&h=800&fit=crop&crop=faces'
}, {
  id: 'cn',
  title: '中华丽人',
  subtitle: 'China',
  desc: '典雅大方，知性优雅',
  gradient: 'from-red-900/40 to-rose-900/40',
  image: 'https://images.unsplash.com/photo-1524502397800-2eeaad7c3fe5?w=600&h=800&fit=crop&crop=faces'
}];
export function CompanionCategories() {
  return <section id="categories" className="py-24 bg-dark-900" data-id="element-136">
      <div className="max-w-7xl mx-auto px-6" data-id="element-137">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16" data-id="element-138">
          <div data-id="element-139">
            <motion.h2 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-5xl font-serif text-white mb-2" data-id="element-140">
              精选<span className="text-gold-500" data-id="element-141">伴游</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-gold-500/60 uppercase tracking-[0.2em] text-sm" data-id="element-142">
              Elite Companions
            </motion.p>
          </div>
          <motion.button initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="hidden md:flex items-center text-gold-400 hover:text-white transition-colors text-sm tracking-widest uppercase group mt-6 md:mt-0" data-id="element-143">
            View All{' '}
            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-144" />
          </motion.button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-145">
          {categories.map((cat, index) => <motion.a href="https://www.geylang777-6.site" target="_blank" rel="noopener noreferrer" key={cat.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -10
        }} className="group relative h-[400px] overflow-hidden cursor-pointer border border-white/5 bg-dark-800 block" data-id="element-146">
              {/* Girl Image */}
              <img src={cat.image} alt={cat.subtitle} className="absolute inset-0 w-full h-full object-cover object-top opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700" data-id="element-147" />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-dark-900/60 to-transparent" data-id="element-148"></div>
              <div className={`absolute inset-0 bg-gradient-to-br ${cat.gradient} opacity-30 group-hover:opacity-20 transition-opacity duration-700`} data-id="element-149"></div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-8 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-150">
                <div className="w-12 h-px bg-gold-500 mb-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100" data-id="element-151"></div>
                <h3 className="text-2xl font-serif text-white mb-1" data-id="element-152">
                  {cat.title}
                </h3>
                <p className="text-gold-500/80 text-xs uppercase tracking-widest mb-3" data-id="element-153">
                  {cat.subtitle}
                </p>
                <p className="text-gray-300 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100 transform translate-y-4 group-hover:translate-y-0" data-id="element-154">
                  {cat.desc}
                </p>
              </div>

              {/* Hover Border Effect */}
              <div className="absolute inset-0 border border-gold-500/0 group-hover:border-gold-500/30 transition-colors duration-500 pointer-events-none" data-id="element-155"></div>
            </motion.a>)}
        </div>

        <div className="mt-12 text-center md:hidden" data-id="element-156">
          <button className="inline-flex items-center text-gold-400 text-sm tracking-widest uppercase" data-id="element-157">
            View All <ArrowRight className="ml-2 w-4 h-4" data-id="element-158" />
          </button>
        </div>
      </div>
    </section>;
}